import { render } from "./SubQuestionsEditor.vue?vue&type=template&id=153a9322"
import script from "./SubQuestionsEditor.vue?vue&type=script&lang=js"
export * from "./SubQuestionsEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__